import { CommercialType } from "@adgate/common/types/commercial-type.type";
import { Language } from "@adgate/common/types/language.type";
import { CommercialOffice } from "@adgate/common/types/commercial-office.type";
import { Agency } from "@adgate/common/types/agency.type";
import { Status } from "@adgate/common/types/status.type";

export abstract class Advertisement
{
    public static TYPE_COMMERCIAL: number           = 1;
    public static TYPE_CREATIVITY: number           = 2;
    public static TYPE_PRODUCTIONORDER: number      = 3;
    public static TYPE_PRODUCTIONVERSION: number    = 4;
    
    id!: number;
    referenceCode!: string | null;
    originalFilename!: string | null;
    fileSize!: number | null;
    status!: Status;
    language!: Language;
    type!: CommercialType;
    dateCreated!: number | null;
    dateUploaded!: number | null;
    createdBy!: string | null;
    uploadedBy!: string | null;
    startOfMedia!: number | 0;
    brand!: string | null;
    commercialOffice!: CommercialOffice | null;
    agency!: Agency | null;
    
    constructor()
    {
        this.id = -1;
    }
}